export const endpoints = {
  REGISTERATION: '/register/',
  LOGIN: '/login/',
  RESENDEMAILLINK: '/send-reset-password-email/',
  VERIFY_OTP:"/verify-otp/",
  RESEND_OTP:"/auth/resend-otp/",
  RESETPASSWORD: '/reset-password/',
  UPDATE_PASSWORD: '/update-password/',
  BILLER: '/Biller/',
  PROVIDER: '/Provider/',
  ADMIN: '/Adminprofile/',
  STATEMASTER: '/statemaster/',
  FACILITYTYPE: '/facilitytype/',
  DX_CODE: '/dxreason/',
  VISITREASON: '/visitreason/',
  FACILITY:'/facility/',
  getProviderFaciltyById: "/FacilityListProvider/",
  getProviderFaciltyByIds: "/list/provider-facility/",
  getBillingReportByBiller: "/biller/report-details/",
  getProviderFaciltyTypeById: "/FacilityTypeListProvider/",
  providerTimeSheet: "/timesheet/",
  adminTimeSheet: "/AdminTimeSheetTest/",
  // adminTimeSheet: "/AdminTimeSheetView/",
  providerPatients: "/superbiller/filterview/",
  superBill: "/superbillerview/",
  superBillSubmit: "/SuperBillAuthorizationView/",
  billerProviderMapping: "/ProviderBillersView/",
  // superBillAdmin: "/superbiller/adminview/",
  superBillAdmin: "/superbiller/adminviewtest/",
  // superBillProvider: "/provider/reports/",
  superBillProvider: "/provider/reportstest/",
  copyData: "/provider/copydata/",

  superBillBiller: "/billerproviders/superbillersview/",
  providersbyBillerId: "/BillerProviderListView/",
  excelUpload:'superbiller/uploadapi/',
  updateMultipleReportBybiller: "/ReportsMultiUpdateView/",

  deleteSuperbill:'provider/reportstest/',

  adminGraph:'/DashboardViewTesting/',
  // adminGraph:'/DashboardView/',

  providerGraph:'/ProviderDashboardViewCheck/',
  // providerGraph:'/ProviderDashboardView/',

  patientSeen:'/lastmonth/patientseenview/',
  employee:'/employeeprofileview/',
  employeeProviderList:'/employeeproviderlist/',

  providerListByFacility:'/filter/provider-facilitydata/',

  updateMultipleTimesheet: '/update/timesheetstatus/',
  providerCountGraph: '/superbiller/monthly-count/',
  copyDataDetails: '/provider/copydata-details/',
  userDetail: '/get/userdetails/',

  productivityByFaciltyType:'/productivity-by-facility-type/',
  productivityByFacilty:'/productivity-by-facility-name/',
  productivityByProvider:'/encounter-by-provider/',
  productivityByCPT:'/encounter-by-cpt-code/',
  productivityByDx:'/encounter-by-dx-code/',
  productivityByProviderFacilty:'/provider-facility-graph/',

  ProviderListByFacility:"/list/providers-details/"
};